import { FormJourneyItem, LeadForm } from "@plura/shared/types";
import { AnimatePresence, motion } from "framer-motion";
import { z } from 'zod';
import { cn } from "@plura/shared/utils";
import CheckboxGroup from "../../../../molecules/CheckboxGroup";
import { useFormContext } from "react-hook-form";
import { dynamicQuestionContent, getCurrentResponseScore } from "@plura/shared/lead-forms";

interface Props {
  id: string;
  step: FormJourneyItem
  leadForm: LeadForm;
  editorMode: boolean;
  previewMode: boolean;
  active: boolean;
  handleAnswer?: () => void;
  onContentClick?: (fieldName: string, blockId: string) => void;
  hiddenFields?: {
    field: string;
    value: string;
  }[];
}

const StatementScreen = ({ id, step, editorMode, previewMode, leadForm, active, handleAnswer, onContentClick, hiddenFields }: Props) => {
  const form = useFormContext();
  const { conversationId, ...userResponses } = form.getValues()
  const currentResponseScore = userResponses
    ? getCurrentResponseScore(userResponses, leadForm)
    : 0

  const handleContentClick = (field: 'content' | 'secondaryContent') => {
    if ((!editorMode || (editorMode && previewMode)) || !onContentClick) return
    onContentClick(field, id)
  }

  return (
    <>
      <div className={cn('questionInner')}>
        <div>
          <h4
            onClick={() => handleContentClick('content')}
            className={
              cn(
                'question',
                // !typingDone && 'typing'
              )}
          >
            <motion.span
              dangerouslySetInnerHTML={{
                __html: dynamicQuestionContent({
                  content: step.content,
                  score: currentResponseScore,
                  editMode: editorMode,
                  previewMode: previewMode ?? false,
                  hiddenFields,
                  journeyItems: leadForm.journeyItems ?? [],
                  userResponses
                })
              }}
            />
          </h4>
          {
            step.secondaryContent &&
            <p className={cn('caption')} onClick={() => handleContentClick('secondaryContent')}>
              <motion.span
                dangerouslySetInnerHTML={{
                  __html: dynamicQuestionContent({
                    content: step.secondaryContent,
                    score: currentResponseScore,
                    editMode: editorMode,
                    previewMode: previewMode ?? false,
                    hiddenFields,
                    journeyItems: leadForm.journeyItems ?? [],
                    userResponses
                  })
                }}
              />
            </p>
          }
        </div>
        <div>
          <motion.div className={'answerInputWrapper'}>
            <AnimatePresence initial={false}>
              <motion.div className={'fieldWrapper'}>
                {
                  step.thirdContent
                    ? <div className={'multiChoice'}>
                      <CheckboxGroup
                        id={step.blockId}
                        options={[{ value: 'Yes', label: step.thirdContent, media: null }]}
                        disabledKeySelection={(editorMode && !previewMode) || !active}
                        hideKeyHints={leadForm.showAnswerLetters === false}
                        handleOnChange={handleAnswer}
                      />
                    </div>
                    : <div className={'multiChoice'}>
                      <CheckboxGroup
                        id={step.blockId}
                        options={[
                          { value: 'Yes', label: 'Yes', media: null },
                          { value: 'No', label: 'No', media: null }
                        ]}
                        disabledKeySelection={(editorMode && !previewMode) || !active}
                        hideKeyHints={leadForm.showAnswerLetters === false}
                        handleOnChange={handleAnswer}
                      />
                    </div>
                }
              </motion.div>
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </>
  );
};


export default StatementScreen

export const FormData = z.object({
  answer: z.string().optional(),
});
export type FormData = z.infer<typeof FormData>;